<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent taskContainer">
  <mat-expansion-panel expanded="false" id="headerContent">
    <mat-expansion-panel-header>
      <h1 id="title">{{translation.VehicleLogisticsDesc}}</h1>
    </mat-expansion-panel-header>
    <div id="clientContent">
      <div id="addressContent">
        <mat-card>
          <div class="line">
            <p>{{translation.Client + ':'}}</p>
            <p>{{userData.Name}}</p>
          </div>
          <div class="line">
            <p>{{translation.Contact + ':'}}</p>
            <p>{{userData.Contact}}</p>
          </div>
          <div class="line">
            <p>{{translation.Email + ':'}}</p>
            <p>{{userData.Email}}</p>
          </div>
          <div class="line">
            <p>{{translation.Phone + ':'}}</p>
            <p>{{userData.Phone}}</p>
          </div>
          <div class="line">
            <p>{{translation.AddressLine1 + ':'}}</p>
            <p>{{userData.AddressLine1}}</p>
          </div>
          <div class="line" *ngIf="userData.AddressLine2 != ''">
            <p>{{translation.AddressLine2 + ':'}}</p>
            <p>{{userData.AddressLine2}}</p>
          </div>
          <div class="line">
            <p>{{translation.ZipAndCity + ':'}}</p>
            <p>{{userData.Zip + ' ' + userData.City + ' (' + userData.Region + ')'}}</p>
          </div>
        </mat-card>
      </div>
      <div id="logoContent">
        <img src="../../../../assets/logos/logo_weiss.jpg" alt="CotraLogo" id="logo"/>
      </div>
    </div>
  </mat-expansion-panel>
  <div class="headerContent">
    <button mat-mini-fab class="vehicleButton green" type="button" (click)="addNewOrder()" matTooltip="{{translation.AddAdditionalVehicle}}" matTooltipShowDelay="500">
      <span class="material-icons">add</span>
    </button>
    <button mat-mini-fab class="vehicleButton red" type="button" [disabled]="logisticsOrders.length === 1 || currentOrder.status === 2" (click)="removeOrder()" matTooltip="{{translation.DeleteThisVehicle}}" matTooltipShowDelay="500">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div class="inputContent">
    <mat-tab-group [selectedIndex]="currentOrderIndex" (selectedIndexChange)="changeTab($event)">
      <mat-tab *ngFor="let order of logisticsOrders">
        <ng-template mat-tab-label>
          {{translation.Order + ' ' + (order.index + 1)}}
          <mat-icon *ngIf="order.status === 1" class="statusIcon red">error</mat-icon>
          <mat-icon *ngIf="order.status === 2" class="statusIcon green">check</mat-icon>
        </ng-template>
        <div class="listContent">

          <mat-card *ngIf="order.status === 1" class="bg-danger mb-3">
            <mat-card-content class="d-flex flex-row justify-content-between">
              <p class="whiteText" *ngIf="order.message">{{translation.Message}}: {{order.message}}</p>
              <button type="button" mat-button class="logisticsSendButton" (click)="sendSingleOrder(order, true)">{{translation.SendAgain}}</button>
            </mat-card-content>
          </mat-card>

          <mat-card *ngIf="order.status === 2" class="bg-success mb-3">
            <mat-card-content>
              <p class="whiteText" *ngIf="order.orderNumber">{{translation.OrderNumber}}: {{order.orderNumber}}</p>
              <p class="whiteText" *ngIf="order.message">{{translation.Message}}: {{order.message}}</p>
            </mat-card-content>
          </mat-card>

          <!-- Process Id Dropdown-->
          <mat-form-field class="fieldForm w-100">
            <mat-select [(ngModel)]="order.processId" name="processId" placeholder="{{translation.ProcessId}}" [disabled]="order.status === 2" required>
              <mat-option *ngFor="let processId of processIds" [value]="processId">{{processId}}</mat-option>
            </mat-select>
          </mat-form-field>

          <!-- CustomerReference -->
          <mat-form-field class="fieldForm w-100">
            <input name="customerReference" matInput placeholder="{{translation.Reference}}" [(ngModel)]="order.customerReference" [readonly]="order.status === 2" maxlength="50">
          </mat-form-field>

          <!-- Vin -->
          <mat-form-field class="fieldForm w-100">
            <input name="vin" matInput placeholder="{{translation.ChassisNumber}}" [(ngModel)]="order.vin" [readonly]="order.status === 2" required maxlength="17" minlength="17">
          </mat-form-field>

          <!-- Brand/Make -->
          <mat-form-field class="fieldForm w-100">
            <input name="make" matInput placeholder="{{translation.Brand}}" [(ngModel)]="order.make" [readonly]="order.status === 2" required maxlength="50">
          </mat-form-field>

          <!-- Model -->
          <mat-form-field class="fieldForm w-100">
            <input name="model" matInput placeholder="{{translation.Model}}" [(ngModel)]="order.model" [readonly]="order.status === 2" required maxlength="50">
          </mat-form-field>

        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="footerContent">
    <button type="button" mat-button class="logisticsSendButton" (click)="sendAllOrders()">{{translation.All}}&nbsp;{{translation.Send}}</button>
  </div>
</div>
<app-footer></app-footer>
